var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.secondaryrequired)?_c('b',{staticClass:"success--text"},[_vm._v(_vm._s(_vm.$format.decimal(_vm.primary)))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }